// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import 'lib-flexible/flexible.js'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Print from 'vue-print-nb'

Vue.use(Vueaxios, axios)
// 使用vant 第三方库： https://youzan.github.io/vant/#/zh-CN/intro
Vue.use(vant);
// lazy
Vue.use(VueLazyload);
Vue.use(Print);

// 通用样式
import './assets/style/global.css';
// 项目样式
import './assets/style/project.css';
// filters
import './assets/js/filters.js';
//工具
import Util from './assets/js/util.js';
Vue.prototype.Util=Util;

// mixin  全局混入方法
import mixin from "./assets/js/mixin.js";
Vue.mixin(mixin);

Vue.config.productionTip = false;

axios.interceptors.request.use(function (config) {
  store.dispatch('updateApiLoadingList', 1);//加载队列加一
  if (!config.noloading && store.getters.apiLoadingList.length==1) {
    // 如果设置 CSFCLoading 参数， 则使用城市房产加载图标，否则显示默认加载图标
    let loader = config.CSFCLoading ? 'CSFCloader' : 'Dataloader';
    if(config.lazyloading){//设置了延迟加载加载框
      setTimeout(function(){//延迟出加载等待框（请求很短的接口没必要每次都出）
        if(store.getters.apiLoadingList.length > 0){
          store.dispatch(`show${loader}`);
        }
      }, 2000)
    }else{
      store.dispatch(`show${loader}`);
    }
  }
  if(!config.params) config.params = {};
  //如果请求中没有http域名，则补全请求链接
  if (config.url.indexOf('http') == -1) {
    if (config.url.indexOf('json') >=0) {//如果请求中有json则调用测试地址
      config.url = process.env.STATIC_HOST + config.url;
    } else {//如果没有json
      config.url = location.protocol+'//'+location.hostname+(location.port=='80'?'':':'+location.port) + config.url;
    }
  }
  //设置超时
  if(config.timeout==0){
      config.timeout = process.env.NODE_ENV == 'development' ? 1000*200 : 1000*15;
  }
  //追加渠道码
  //if (config.url.indexOf('channel=') == -1) config.url = config.url+(config.url.indexOf('?')>=0?'&':'?')+'channel='+store.getters.getChannel;

  //追加菜单名
  if (config.url.indexOf('menu=') == -1) config.url = config.url+(config.url.indexOf('?')>=0?'&':'?')+'menu='+store.getters.activeMenu;

  //调试
  if(config.debug){
    console.log("API："+config.url);
  }
  return config;
}, function (error) {
  store.dispatch('updateApiLoadingList', -1);//加载队列减一
  return Promise.reject(error);
})

// 函数节流的时间戳
let timer;
axios.interceptors.response.use(
  response => {
    store.dispatch('updateApiLoadingList', -1);//加载队列减一
    if (store.getters.apiLoadingList.length <=0 ){//最后一个负责关闭loading（即使没有加载loading）
      store.dispatch(`hideCSFCloader`);
      store.dispatch(`hideDataloader`);
    }
    // 是否是调用的登录接口
    const isLogin = response.config.url.includes("uid-pwd-login") || response.config.url.includes("phone-login");
    // 不是登录接口返回的 401 才需要弹框提示再次登录
    if (response.data.status == 401 && !isLogin && !timer) {
      //if (confirm('获取用户信息失败！错误码：'+response.data.errcode+'m:'+ response.data.errmsg+'，是否尝试再次登录？')){
      timer = setTimeout(() => {
        //if (confirm('获取用户信息失败！是否尝试再次登录？')){
          store.dispatch('updateUser', {userToken: ''}); //登录信息设置为空
          router.push({name: 'login', query: {to: encodeURIComponent(location.href)}});
        //}
      }, 200);
    } else if (response.data.status==400) {
      //Vue.prototype.$alert(response.data.errmsg);
    } else if (response.data.status==500) {
      let message = response.data.errmsg || '系统异常';
      Vue.prototype.$dialog.alert({message});
      // Vue.prototype.$alert(response.data.errmsg);
    }
    return response;
  },
  error => {
    store.dispatch('updateApiLoadingList', -1);//加载队列减一
    if (store.getters.apiLoadingList.length<=0){//最后一个负责关闭loading（即使没有加载loading）
      store.dispatch(`hideCSFCloader`);
      store.dispatch(`hideDataloader`);
    }
    // 手动取消axios请求，不需要弹框提示
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    let emsg ='系统异常：' + error;
    if(error.indexOf && error.indexOf('timeout') >= 0) {
       emsg = '请求超时！请稍后再试';
    }
    Vue.prototype.$toast(emsg);
    return Promise.reject(error)
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js